<template>
    <div data-cy="container_campaign_detail_info">
        <div class="flex justify-between" data-cy="container_campaign_header">
            <div class="box-name font-bold text-18 text-a-blue-2140a6" data-cy="text_campaign_title">{{campaign.name}}</div>
            <div>
                <img v-show="isFavorite" class="w-6 h-6" data-cy="btn_campaign_favorite_active" :src="icFavUrl('ic-favorite_active')" @click="clickFav()" />
                <img v-show="!isFavorite" class="w-6 h-6" data-cy="btn_campaign_favorite_inactive" :src="icFavUrl('ic-favorite_inactive')" @click="clickFav()"/>
            </div>
        </div>
        <div class="text-16 text-a-blue-2140a6 mt-0.5" data-cy="container_campaign_point">
            <span data-cy="text_campaign_point_cost">{{getPointTxt()}}</span>
        </div>
    </div>
</template>
<script>
import ConfigManager from "@/config/ConfigManager.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "DetailInfo",
    mixins: [LocaleMixin],
    props: {
        campaign: { type: Object, required: true },
    },
    data: function() {
        return {
            isFavorite: this.campaign.isFavourite,
        }
    },
    methods: {
        getPointTxt: function () {
            var pointTypeTxt = this.campaign.pointType && this.campaign.pointType != 'use'
                            ? this.lbl.detail.get_point
                            : this.lbl.detail.use_point;

            var pointUnit = this.localeCode === 1033 && this.campaign.pointPerUnit > 1
                        ? this.lbl.detail.point_unit + 's'
                        : this.lbl.detail.point_unit;

            return `${pointTypeTxt} ${this.campaign.pointPerUnit} ${pointUnit}`;
        },
        agencyLogoUrl: function() {
            return ConfigManager.getBlobUrl() + "/agencies/" + this.campaign.agencyID;
        },
        clickFav: function() {
            this.$emit('clickFav');
        },
        updateFavorite: function(isFavorite) {
            this.isFavorite = isFavorite;
        },
        icFavUrl: function(name) {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/icons/${name}.svg`;
        },
    },
}
</script>
<style lang="scss" scoped>
.box-name {
    width: 90%;
}
</style>
